import React from "react";
import { SnackbarContent, CustomContentProps } from "notistack";

export const CustomSuccess = React.forwardRef((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    ...other
  } = props;

  return (
    <SnackbarContent
      ref={ref}
      style={{
        backgroundColor: "#deffe8",
        color: "rgba(0, 0, 0,1)",
        borderLeft: "4px  solid #17ea80", // Optional border for more contrast
        fontSize: "1rem",
        marginRight: "60px",
        padding: "10px 20px",

        marginBottom: "0px",
        backdropFilter: "blur(10px)", // Blurry background
        boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
        borderRadius: "15px", // Semi-transparent white
      }}
      role="alert"
    >
      {" "}
      {message}
    </SnackbarContent>
  );
});

export const CustomError = React.forwardRef((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    ...other
  } = props;

  return (
    <SnackbarContent
      style={{
        backgroundColor: "#ffd1d0",
        color: "rgba(0, 0, 0,1)",
        borderLeft: "4px  solid #e91a17", // Optional border for more contrast
        fontSize: "1rem",
        marginRight: "60px",
        marginBottom: "0px",
        padding: "10px 20px",
        backdropFilter: "blur(10px)", // Blurry background
        boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
        borderRadius: "15px",
        // Semi-transparent white
      }}
      ref={ref}
      role="alert"
    >
      {message}
    </SnackbarContent>
  );
});

// do warning
export const CustomWarning = React.forwardRef((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    ...other
  } = props;

  return (
    <SnackbarContent
      style={{
        backgroundColor: "#fdd6a0",
        color: "rgba(0, 0, 0,1)",
        borderLeft: "4px  solid #ff9800", // Optional border for more contrast
        fontSize: "1rem",
        marginRight: "60px",
        marginBottom: "0px",
        padding: "10px 20px",
        backdropFilter: "blur(10px)", // Blurry background
        boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
        borderRadius: "15px", // Semi-transparent white
      }}
      ref={ref}
      role="alert"
    >
      {message}
    </SnackbarContent>
  );
});
